import { render } from "./DateEditor.vue?vue&type=template&id=252800a2&scoped=true"
import script from "./DateEditor.vue?vue&type=script&lang=js"
export * from "./DateEditor.vue?vue&type=script&lang=js"

import "./DateEditor.vue?vue&type=style&index=0&id=252800a2&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252800a2"]])

export default __exports__